import React, { useState, useEffect } from "react"
import styled from "styled-components"
import _ from 'lodash'

import Text from "./Text"
import theme from "../../styles/theme"
import Loading from "@display/LoadingSpinner"
import Link from "../util/link"
const { colors, breakPoints: { screenQuery } } = theme

function makeApiCall({ spreadsheetId, sheetName, setData }) {
    var params = {
        // The ID of the spreadsheet to retrieve data from.
        spreadsheetId: spreadsheetId,
        // The A1 notation of the values to retrieve.
        ranges: [sheetName || "Vendors"],
        // How values should be represented in the output.
        // The default render option is ValueRenderOption.FORMATTED_VALUE.
        valueRenderOption: 'FORMATTED_VALUE',
        // How dates, times, and durations should be represented in the output.
        dateTimeRenderOption: 'FORMATTED_STRING',
    };

    var request = gapi.client.sheets.spreadsheets.values.batchGet(params);
    request.then(function (response) {
        // TODO: Change code below to process the `response` object:
        setData(response.result)
    }, function (reason) {
        console.error('error: ' + reason.result.error.message);
    });
}

function initClient() {
    var API_KEY = 'AIzaSyDk6_rb6kPUlGSVYSqMUpUvD2inf0A812A';
    var CLIENT_ID = '694749353743-tpq2u5evco4pl3vsgo6mennfb8iievak.apps.googleusercontent.com';
    var SCOPE = 'https://www.googleapis.com/auth/spreadsheets.readonly';

    gapi.client.init({
        'apiKey': API_KEY,
        'clientId': CLIENT_ID,
        'scope': SCOPE,
        'discoveryDocs': ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
    }).then(function () {
        gapi.auth2.getAuthInstance().isSignedIn.listen(updateSignInStatus);
        updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
    });
}
function handleClientLoad() {
    gapi.load('client:auth2', initClient);
}
function updateSignInStatus(isSignedIn) {
    if (isSignedIn) {
        makeApiCall();
    }
}

const WithApi = (props) => {

    const [data, setData] = useState(null)

    useEffect(() => {
        if (typeof window === "object" && window.gapi) {
            handleClientLoad()
            setTimeout(() => {
                makeApiCall({
                    spreadsheetId: props.id,
                    //sheetName: 'Vendors',
                    setData
                })
            }, 2500)
        }
    }, [])

    return (
        <>
            <script async defer src="https://apis.google.com/js/api.js"
                onload="this.onload=function(){};handleClientLoad()"
                onreadystatechange="if (this.readyState === 'complete') this.onload()">
            </script>
            {data ? <GoogleSheetTable
                initTable={data?.valueRanges[0].values}
                {...props}
            />
                :
                <div css={{ textAlign: "center" }}>
                    <Loading />
                </div>}
        </>

    )
}

const Wrapper = styled.div`
    margin: 40px auto;
    ${screenQuery.small}{
        >:first-child{
            display: none;
        }
    }
`
const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.length}, ${props => 100 / props.length}%);
    > * {
        border-right: ${props => props.last ? `none` : `1px solid ${colors.grayscale.gray}`};
    }
    p {
        margin: 0;
        word-wrap: break-word;
    }
    a {
        color: #777;
    }
    background-color: ${props => props.stripe ? colors.grayscale.stone : colors.grayscale.white};

    ${screenQuery.small}{
        grid-template-columns: 1fr;
        padding: 10px;
    }
`
const TableHead = styled(Row)`
    background-color: ${colors.grayscale.main};
    * {color: ${colors.grayscale.white} !important;}
    p {
        font-size: 16px;
        font-family: "ProximaNova-SemiBold";
        }
`
const TableBody = styled.div``

const Cell = styled.div`
    padding: 15px 20px;
    height: 100%;
    min-width: 0;
    border-right: ${props => props.last ? `none` : `auto`};
    .vendor {
        font-size: 16px;
    }
    .item {
        font-size: 14px;
        color: #777;
    }
    .mobile {
        display: none;
        font-family: "ProximaNova-SemiBold";
    }
    ${screenQuery.small}{
        .mobile{
            color: #333;
            display: inline-block;
            min-width: 20%;
            height: 100%;
        }
        border: none;
        padding: 5px;
    }
`


const GoogleSheetTable = ({ initTable, columns = ['Vendor', 'Description', 'Physical Address', 'Website'] }) => {
    const [table, setTable] = useState(() => initTable)

    const visibleColumnIndices = []
    columns.forEach(column => {
        const found = table && table[0].indexOf(column)
        if (typeof found === "number") { visibleColumnIndices.push(found) }
    })

    const rows = table?.map(row => {
        return visibleColumnIndices.map(show => row[show])
    })

    return (
        table && <Wrapper>
            <TableHead length={rows[0].length}>
                {rows[0].map((cell, index) =>
                    <Cell last={index === rows[0].length - 1}>
                        <Text semiBold component="b5">
                            {cell ===
                                "DESCRIPTION" ? "SERVICE" :
                                cell ===
                                    "PHYSICAL ADDRESS" ? "ADDRESS" :
                                    cell}
                        </Text>
                    </Cell>
                )}
            </TableHead>
            <TableBody>
                {rows.slice(1, rows.length).map((row, index) =>
                    <Row stripe={index % 2} length={row.length}>
                        {row.map((cell, index) =>
                            <Cell last={index === row.length - 1}>
                                <Text
                                    semiBold={index === 0}
                                    component="b5"
                                    className={index === 0 ? "cell vendor" : "cell item"}
                                >
                                    <span className="mobile">
                                        {rows[0][index] ===
                                            "DESCRIPTION" ? "SERVICE" :
                                            rows[0][index] ===
                                                "PHYSICAL ADDRESS" ? "ADDRESS" :
                                                rows[0][index]}:
                                                :&nbsp;
                                    </span>
                                    {cell.indexOf('http') >= 0 ?
                                        <Link to={cell}>
                                            {cell}
                                        </Link>
                                        :
                                        cell}
                                </Text>
                            </Cell>
                        )}

                    </Row>)}
            </TableBody>
        </Wrapper>
    )
}

export default WithApi